export default "__VITE_ASSET__92606034__"